import Header from "../components/header/Header";
import Footer from "../components/footer/Footer";
import appPlay from "../assets/images/app-play.svg";
import googlePlay from "../assets/images/google-play.svg";
import tickCircleWhite from "../assets/images/tick-circle-white.svg";
import lovely from "../assets/images/lovely.svg";
import crownPro from "../assets/images/crown-pro.svg";
import share from "../assets/images/share.svg";
import closeCircle from "../assets/images/close-circle.svg";
import mobilApp from "../assets/images/mobil-app.webp";
import { useEffect, useState } from "react";
import { scrollToTop, selectLoader } from "../utils/Helper";
import APIService from "../utils/APIService";

const Pricing = () => {
  const [plans, setPlans] = useState([]);
  const [isLoading, setLoading] = useState([]);
  const [isActivating, setActivating] = useState(false);

  // useEffect(() => {
  //   // Ensure Chargebee is initialized
  //   if (window.Chargebee && window.Chargebee.getInstance) {
  //     const cbInstance = window.Chargebee.getInstance();
  //     cbInstance.setCheckoutCallbacks({
  //       success: function (hostedPageId) {
  //         console.log("Checkout successful!", hostedPageId);
  //       },
  //       error: function (error) {
  //         console.error("Error during checkout:", error);
  //       },
  //     });
  //   }

  //   // Manually re-scan the DOM and attach event handlers after React renders
  //   if (window.Chargebee && window.Chargebee.registerAgain) {
  //     window.Chargebee.registerAgain(); // Reattach Chargebee handlers
  //   }
  // }, [plans]);

  useEffect(() => {
    scrollToTop();
    fetchPlans();
  }, []);

  const fetchPlans = async () => {
    try {
      const planData = await APIService.get(`/subscription/plans`);
      console.log(planData);
      setPlans(planData.plans);
      // setBlogDetails(blogData);
    } catch (error) {
      // setError(true);
      console.error("Error fetching blog details:", error);
    } finally {
      setLoading(false);
    }
  };

  const activateSubscription = async (itemPriceId) => {
    if (!itemPriceId || isActivating) return;

    try {
      setActivating(true);

      const payload = { itemPriceId };

      const response = await APIService.post(
        "/subscription/create-checkout-hosted-page",
        payload,
      );

      const checkoutUrl = response?.hostedPage?.url;
      console.log("Received Stripe checkout URL:", checkoutUrl);
      if (!checkoutUrl) {
        throw new Error("Stripe checkout URL not found.");
      }

      // 🔥 Redirect to Stripe Checkout
      window.location.href = checkoutUrl;
    } catch (error) {
      console.error("Error starting Stripe checkout:", error);
      setActivating(false);
    }
  };

  return (
    <div className="wrapper">
      <Header isBackEnable={false} />
      <main className="main-curve-top">
        <div className="happy-left">&nbsp;</div>
        <div className="happy-right">&nbsp;</div>

        <section className="plan-sec pricingPage-plan-sec">
          <div className="container">
            <div className="head-top-content">
              <h2>Simple, Transparent, No Surprises</h2>
              <p>Choose a plan that suits your business needs</p>
            </div>
            {/* <div className="Choose-plan-head">
              <div className="payment-switch">
                <p>Monthly </p>
                <div className="payment-switch-form">
                  <input type="checkbox" hidden="hidden" id="plan-type" />
                  <label className="switch" for="plan-type"></label>
                </div>
                <p>Yearly</p>
              </div>
              <button className="save-btn">Save 65%</button>
            </div> */}

            <div className="pricing-details row justify-content-center">
              {isLoading ? (
                <div className="pt-5">{selectLoader(50)}</div>
              ) : (
                plans.map((plan) => {
                  const priceObj = plan.prices?.[0]; // assume one price per plan
                  const monthlyPrice = (priceObj?.price || 0) / 100; // cents to dollars

                  return (
                    <div
                      className="col-lg-4 col-md-12 col-sm-12 annually"
                      key={plan.id}
                    >
                      <div className="pricing-detailsCard">
                        <h6>
                          <img src={lovely} alt="plan-icon" />{" "}
                          {plan.externalName}
                        </h6>
                        <span>
                          ${monthlyPrice.toFixed(2)}{" "}
                          <sup>
                            /{" "}
                            {priceObj?.period_unit === "month"
                              ? "Month"
                              : priceObj?.period_unit}
                          </sup>
                        </span>
                        {/* Safely inject features list from description */}
                        <div
                          dangerouslySetInnerHTML={{
                            __html: plan.description
                              .replace(
                                /<li>/g,
                                `<li class="active"><img src="${tickCircleWhite}" alt="tick" /><p>`,
                              )
                              .replace(/<\/li>/g, "</p></li>"),
                          }}
                        />

                        <button
                          className="enroll-btn"
                          onClick={() => activateSubscription(priceObj?.id)}
                          disabled={isActivating}
                        >
                          {isActivating ? selectLoader(20) : "Get Started"}
                        </button>
                      </div>
                    </div>
                  );
                })
              )}
              {/* <div className="col-lg-4 col-md-12 col-sm-12 monthly">
                <div className="pricing-detailsCard">
                  <div className="crownPro-cover">
                  <h6> <img src={crownPro} alt="crownPro" /> Pro</h6>
                   <button className="popular-btn">Popular</button>
                  </div>
                  <p>
                  Perfect plan for professionals!
                  </p>
                  <span>
                  $12 <sup>/ Month</sup>
                  </span>
                  <h5>Ideal for professionals managing multiple milestones.</h5>
                  <ul>
                    <li className="active">
                     <img src={tickCircleWhite} alt="tickCircleWhite" />
                      <p>Everything in Starter Plan</p>
                    </li>
                    <li className="active">
                     <img src={tickCircleWhite} alt="tickCircleWhite" />
                      <p>Change Order Management</p>
                    </li>
                    <li className="active">
                      <img src={tickCircleWhite} alt="tickCircleWhite" />
                      <p>Milestone tracking</p>
                    </li>
                    <li className="active">
                    <img src={tickCircleWhite} alt="tickCircleWhite" />
                      <p>AI-driven recommendations</p>
                    </li>
                    <li>
                     <img src={closeCircle} alt="closeCircle" />
                      <p>Full-suite automation</p>
                    </li>
                  </ul>
                  <a
                    href="https://app.servicemvp.com/payment/cart?id=aWQ9NjE="
                    class="enroll-btn"
                  >
                  Get Started
                  </a>
                 
                </div>
              </div>
              <div className="col-lg-4 col-md-12 col-sm-12 annually ">
                <div className="pricing-detailsCard ">
                  <h6><img src={share} alt="crownPro" /> Enterprise</h6>
                  <p>
                  Best suits for great company!
                  </p>
                  <span>
                  $33 <sup>/ Month</sup>
                  </span>
                  <h5>Best for large teams needing full automation.</h5>
                  <ul>
                    <li className="active">
                     <img src={tickCircleWhite} alt="tickCircleWhite" />
                      <p>Everything in Pro Plan</p>
                    </li>
                    <li className="active">
                     <img src={tickCircleWhite} alt="tickCircleWhite" />
                      <p>Full-suite automation</p>
                    </li>
                    <li className="active">
                      <img src={tickCircleWhite} alt="tickCircleWhite" />
                      <p>Advanced integrations</p>
                    </li>
                    <li className="active">
                    <img src={tickCircleWhite} alt="tickCircleWhite" />
                      <p>Priority support</p>
                    </li>
                    <li className="active">
                     <img src={tickCircleWhite} alt="closeCircle" />
                      <p>Custom workflow automations</p>
                    </li>
                  </ul>
                  <a
                    href="https://app.servicemvp.com/payment/cart?id=aWQ9NjE="
                    class="enroll-btn"
                  >
                  Get Started
                  </a>
                </div>
              </div> */}
            </div>
          </div>
        </section>

        <section className="business-sec">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 col-md-6">
                <div className="business-content">
                  <h3>Your Business, Your Rules – Access It Anywhere</h3>
                  <p>
                    Take control of your projects with our powerful mobile and
                    web applications. Whether you’re in the office or on the
                    move, stay connected with your clients, streamline
                    workflows, and maximize profits—all from one intuitive
                    platform.
                  </p>
                  <div className="play-btn-group">
                    <a href="#">
                      {" "}
                      <img src={appPlay} alt="appPlay" />
                    </a>
                    <a href="#">
                      {" "}
                      <img src={googlePlay} alt="googlePlay" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-6">
                <img src={mobilApp} alt="mobilApp" className="mobilApp" />
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Pricing;
